export default "__VITE_ASSET__CH9BOum8__"